exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".navbrand-supersafra[data-v-1f2ea396],.navbrand-supersafra[data-v-1f2ea396]:focus,.navbrand-supersafra[data-v-1f2ea396]:hover{text-decoration:none!important;font-family:Libre Baskerville,serif;color:#3e4095;text-shadow:#fff 1px 1px 1px;letter-spacing:-4px;vertical-align:text-middle;font-size:20px}.icone-navbrand-supersafra[data-v-1f2ea396]{width:27.5px}", ""]);

// exports
